import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

export const useBookmarkContentDelete = () => {
  const deleteBookmarkContent = useCallback((id) => {
    return new Request(`${API_BASE_URL}/api/v3/content-bookmark/${id}/`, {
      method: "DELETE",
    });
  }, []);

  return useRestMutation(deleteBookmarkContent);
};

export default useBookmarkContentDelete;
